// extracted by mini-css-extract-plugin
export default {"seflPayContainer":"SelfPayPage_seflPayContainer__cxSk+","paymentForm":"SelfPayPage_paymentForm__Fu0nU"};